import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../utils/api';

export const STATUS_ENDPOINT = (complaintTypeId) =>
  `/api/v1/complaint-types/${complaintTypeId}/statuses`;

const rejectRequest = (error, thunkApi) =>
  thunkApi.rejectWithValue({
    status: error?.response?.status ?? error?.status,
    message:
      error?.response?.data?.message ??
      error?.response?.data?.error ??
      error?.message ??
      'Something went wrong',
  });

export const fetchStatuses = createAsyncThunk(
  'status/fetchStatuses',
  async (complaintTypeId, thunkApi) => {
    try {
      const response = await api.get(STATUS_ENDPOINT(complaintTypeId), {
        signal: thunkApi.signal,
      });
      return response.data;
    } catch (error) {
      return rejectRequest(error, thunkApi);
    }
  },
);
